<template>
    <el-dialog
        :visible="visibleDialog"
        width="80%"
        @close="handleClose">
        <el-table
            :data="tableData"
            @selection-change="handleSelect"
			empty-text="暫無數據">
            <el-table-column
                type="selection">
            </el-table-column>
            <!-- 商品名称 -->
            <el-table-column
                label="商品名稱"
                prop="goods_name"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 数量 -->
            <el-table-column
                label="數量"
                width="150">
                <template #default="{ row }">
                    <el-input-number
                        v-model="row.num"
                        size="mini"
                        :min="1">
                    </el-input-number>
                </template>
            </el-table-column>
            <!-- 规格 -->
            <el-table-column
                label="規格"
                width="220">
                <template #default="{ row }">
                    <el-select
						placeholder="請選擇"
                        v-model="row.goods_specification_id"
                        :disabled="row.attr2.length==0">
                        <el-option
                            v-for="item in row.attr2"
                            :key="item.id"
                            :label="item.attr_value"
                            :value="item.goods_attr_id">
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>
            <!-- 颜色 -->
            <el-table-column
                label="顏色"
                width="220">
                <template #default="{ row }">
                    <el-select
						placeholder="請選擇"
                        v-model="row.goods_attr_id"
                        :disabled="row.attr.length==0">
                        <el-option
                            v-for="item in row.attr"
                            :key="item.id"
                            :label="item.attr_value"
                            :value="item.goods_attr_id">
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>
        </el-table>
        <div class="collect-handle">
            <el-button 
                type="primary"
                @click="handleQcart"
                plain>
                加入報價車
            </el-button>
			<el-button
			    type="primary"
			    @click="handleCart"
			    plain>
			    加入購物車
			</el-button>
            <el-button 
                type="danger"
                @click="handleCollect"
                plain>
                取消收藏
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                selected: []
            }
        },
        props: {
            visibleDialog: Boolean,
            tableData: Array
        },
        methods: {
            handleClose() {
                this.$emit('handle-close')
            },
            handleSelect(selection) {
                this.selected = selection;
            },
            handleCart() {
                this.$emit('handle-cart', this.selected);
            },
            handleQcart() {
                this.$emit('handle-qcart', this.selected);
            },
            handleCollect() {
                this.$emit('handle-collect', this.selected);
            }
        }
    }
</script>

<style scoped>
.collect-handle {
    margin-top: 20px;
    text-align: right;
}
</style>